<i18n>
{
"en": {
  "CHOOSEFILTERBY": "Choose Filter By",
  "MANAGEABSENCES": "Manage Absences",
  "PICK-UP/DROP-OFF": "Pick-up/Drop-off",
  "REASON": "Reason",
  "SICKNESS": "Sickness",
  "VACATION": "Vacation",
  "EMERGENCY": "Emergency",
  "PERSONAL": "Personal",
  "MARKABSENCE": "Mark Absence",
  "ADDNEWABSENCE": "Add New Absence",
  "SCHOOL": "School",
  "BUS": "Bus",
  "FILTERBYREASON": "Filter by reason",
  "PICKARANGE": "Pick a range",
  "SEARCHSTUDENTNAME": "Search student name",
  "LOADING": "Loading...",
  "NAME": "Name",
  "DATE": "Date",
  "GRADE": "Grade",
  "CLASS": "Class",
  "SENDMESSAGE": "Send Message",
  "EDITABSENCE": "Edit Absence",
  "DELETEABSENCE": "Delete Absence",
  "AREYOUSUREYOUWANTTO": "Are you sure you want to",
  "RESTORETHISABSENCE": "restore this absence?",
  "DEACTIVATETHISABSENCE": "deactivate this absence?",
  "CANCEL": "Cancel",
  "CONFIRM": "Confirm",
  "TO": "To",
  "WRITEANOTE": "Write a note",
  "SUCCESSFULLYDELETED": "Successfully deleted",
  "OPERATIONFAILED": "Operation failed",
  "STUDENTHASNOGUARDIAN": "Student has no guardian",
  "MORNINGBUS": "Morning Bus",
  "AFTERNOONBUS": "Afternoon Bus",
  "NOBUS": "No Bus",
  "REPORTEDBY": "Reported-By",
  "GUARDIAN": "Guardian",
  "NAANI": "Supervisor"  
},
"ar": {
  "CHOOSEFILTERBY": "اختر الفلتر المطلوب",
  "MANAGEABSENCES": "إدارة غياب",
  "PICK-UP/DROP-OFF": "حمل / نزل الطلاب",
  "REASON": "السبب",
  "SICKNESS": "المرض",
  "VACATION": "الاجازة",
  "EMERGENCY": "حالة طوارق",
  "PERSONAL": "اسباب شخصية",
  "MARKABSENCE": " سجل غياب ",
  "ADDNEWABSENCE": "إضافة غياب جديد",
  "SCHOOL": "المدرسة",
  "BUS": "حافلة",
  "FILTERBYREASON": " تصفية حسب السبب",
  "PICKARANGE": " اختيار مجموعة",
  "SEARCHSTUDENTNAME": " ابحث عن اسم الطالب",
  "LOADING": "جار التحميل...",
  "NAME": "الاسم",
  "DATE": "التاريخ",
  "GRADE": "الدرجة",
  "CLASS": "الصف",
  "SENDMESSAGE": "إرسال رسالة",
  "EDITABSENCE": "تحرير الغياب",
  "DELETEABSENCE": "حذف غياب",
  "AREYOUSUREYOUWANTTO": "هل أنت متأكد أنك تريد",
  "RESTORETHISABSENCE": "استعادة الغياب",
  "DEACTIVATETHISABSENCE": "تعطيل هذا الغياب",
  "CANCEL": "إلغاء",
  "CONFIRM": "تؤكد",
  "TO": "إلى",
  "WRITEANOTE": "اكتب ملاحظة",
  "SUCCESSFULLYDELETED": "تم حذفها بنجاح",
  "OPERATIONFAILED": "فشل العملية",
  "STUDENTHASNOGUARDIAN": "ليس لطالب ولي أمر",
  "MORNINGBUS": "حافلة الصباح",
  "AFTERNOONBUS": "حافلة المساء",
  "NOBUS": "لا يوجد اي حافلة",
  "REPORTEDBY": "تم عمل تقرير بواسطة",
  "GUARDIAN": "ولي الامر",
  "NAANI": "مشرفة"
  }
}
</i18n>
<template>
  <div>
    <el-card class="card-border" ref="card" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <span style="line-height: 36px;" class="title">{{$t('MANAGEABSENCES')}}</span>

        <el-button :disabled="!isAllowed('save')" @click="addAbsence" style="float: right;" icon="plus">{{$t('ADDNEWABSENCE')}}</el-button>
      </div>

      <div ref="filter" class="filters">
        <el-row :gutter="20">
          <el-col :span="3">
            <el-button  style="width: 100%;" v-on:click="switchTo()">
              <i class="fa" v-bind:class="[absenceFrom!=='bus' ? 'fa-university' : 'fa-bus']"></i>
              <span v-text="absenceFrom!=='bus' ? $t('SCHOOL') : $t('BUS')"></span>
            </el-button>

          </el-col>
          <el-col :span="4">
            <el-select   @change="changedFilter"  v-model="filter" :placeholder="$t('CHOOSEFILTERBY')">
              <el-option
                v-if="item.value!=active_filter"
                :key="index" v-for="(item, index) in options"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>

         <el-col :span="4"  v-if="active_filter=='reason'">
             <el-select :disabled="loading"  v-model="Reason" :placeholder="$t('FILTERBYREASON')" clearable  @change="getAbsences(true)">
              <el-option
                :key="key"
                v-for="(item, key) in reasons"
                :label="item"
                :value="key">
              </el-option>
            </el-select>     
           </el-col>         
         <el-col :span="4"  v-if="active_filter=='date'">
              <el-date-picker
                v-model="date"
                type="daterange"
                @change="getAbsences(true)"
                :placeholder="$t('PICKARANGE')">
              </el-date-picker>    
           </el-col>
          <el-col :span="4" v-if="active_filter=='name'">
               <el-autocomplete
                v-model="FullName"
                :fetch-suggestions="querySearch"
                :placeholder="$t('SEARCHSTUDENTNAME')"
                @select="searchStudent"
                :icon = "FullName ? 'circle-cross' : ''"
                :on-icon-click="removeNameFilter"
              ></el-autocomplete>
           </el-col>                       
        </el-row>
      </div>

      <el-table
       v-loading="new_page || loading"   
        :element-loading-text="$t('LOADING')"
        :data="listAbsences"
        highlight-current-row
        :height="tableHeight"
        stripe
        style="width: 100%">

        <el-table-column
          :label="$t('NAME')"
          min-width="200"
          align="left"
        >
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.ImagePath, 'student')" alt="" class="img-circle" style="width: 50px; float: left;">
            {{_FullName({NameEN: scope.row.FullName_EN, NameAR: scope.row.FullName_AR})}}

          </template>
        </el-table-column>

        <el-table-column
          :label="$t('DATE')"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span v-text="date_format(scope.row.AbsentDate)"></span>
          </template>
        </el-table-column>

        <el-table-column
          :label="(absenceFrom=='bus' ? $t('PICK-UP/DROP-OFF') : $t('REASON'))"
          align="center"
          min-width="150"
         >
          <template slot-scope="scope">
            {{(absenceFrom=='bus' ? $t(scope.row.Direction.title) : $t(scope.row.Reason))}}
          </template>
        </el-table-column>

        <el-table-column
          prop="Grade"
          :label="$t('GRADE')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="Class"
          :label="$t('CLASS')"
          align="center">
        </el-table-column>
        <el-table-column
          :label="$t('REPORTEDBY')"
          align="center"
         >
          <template slot-scope="scope">
            <el-tag type="primary">{{$t(scope.row.ReportedBy)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          class="actions">

          <template slot-scope="scope">
          <el-tooltip v-if="isAllowed('send', 'report/message')" :content="$t('SENDMESSAGE')" placement="top">
            <el-button type="text" @click="showMessageModal(scope.row)"><i class="fa fa-envelope"></i></el-button>            
          </el-tooltip>
          <el-tooltip v-if="isAllowed('save')" :content="$t('EDITABSENCE')" placement="top">
            <el-button type="text" @click="showAbsence(scope.row, scope.$index)"><i class="fa fa-pencil"></i></el-button>
          </el-tooltip>
          <el-tooltip v-if="isAllowed('delete')" :content="$t('DELETEABSENCE')" placement="top">
              <el-popover
                trigger="manual"
                placement="left"
                width="160"
                @show="student=listAbsences[scope.$index]"
                v-model="listAbsences[scope.$index].Deleted">
                 <p> {{$t('AREYOUSUREYOUWANTTO') + ' '}} {{listAbsences[scope.$index].Status==0 ? $t('DEACTIVATETHISABSENCE') : $t('RESTORETHISABSENCE')}}</p>
                 <el-input
                  type="textarea"
                  :placeholder="$t('WRITEANOTE')"
                  v-model="listAbsences[scope.$index].DeleteNote">
                  </el-input>
                <div style="text-align: right; margin: 0; margin-top:5px">
                  <el-button size="mini" type="text" @click="listAbsences[scope.$index].Deleted = false">{{$t('CANCEL')}}</el-button>
                  <el-button type="primary" size="mini" @click="toggleStatus(scope.$index)">{{$t('CONFIRM')}}</el-button>
                </div>
                <el-button style="margin-left:10px" type="text" @click="preDelete(scope.$index)" slot="reference"><i class="fa fa-times"></i> </el-button>
              </el-popover>            
          </el-tooltip>                               
          </template>
        </el-table-column>
      </el-table>

      <div ref="pagination" style="padding:10px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 30, 50, 70, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next"
          :total="totalAbsences">
        </el-pagination>
      </div>
   <el-absence-dialog @update="updateAbsence" :data="absence" :status="absence_status" :selected-student="student" :search="serachStudent" :server-check="serverCheck" :visible.sync="absenceBox"></el-absence-dialog>
   <el-message-dialog :visible.sync="messageBox" :showRemove="false" :studentList="messageStudent" :parent="parent"></el-message-dialog>
    </el-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import Vue from 'vue'
  import _ from 'lodash'
  import qs from 'qs'
  import AbsenceDialog from '@/components/dialogs/Absence'
  import MessageDialog from '@/components/dialogs/Message'
  export default {
    components: {'el-absence-dialog': AbsenceDialog, 'el-message-dialog': MessageDialog},
    data () {
      return {
        filter: null,
        active_filter: 'name',
        currentPage: 1,
        loading: true,
        absences: {'bus': [], 'school': []},
        absenceFrom: 'bus',
        student: {},
        messageStudent: [],
        parent: {},
        currentRow: null,
        tableHeight: 0,
        absence: {},
        direction: [],
        Reason: null,
        FullName: null,
        StudentID: null,
        date: [null, null],
        messageBox: false,
        absenceBox: false,
        totalAbsences: 0,
        visitedPage: [1],
        new_page: false,
        limit: 20,
        pickedIndex: 0,
        prevIndex: 0,
        serachStudent: false,
        serverCheck: false,
        absence_status: false,
        autoSource: null
      }
    },
    computed: {
      listAbsences () {
        return this.absences[this.absenceFrom][this.currentPage - 1]
      },
      options () {
        let options = [{
          value: 'name',
          label: this.$t('NAME')
        }, {
          value: 'reason',
          label: this.$t('REASON')
        }, {
          value: 'date',
          label: this.$t('DATE')
        }]
        return options
      },
      reasons () {
        let reasons = {Sickness: this.$t('SICKNESS'), Vacation: this.$t('VACATION'), Emergency: this.$t('EMERGENCY'), Personal: this.$t('PERSONAL')}
        return reasons
      }
    },
    mounted () {
      this.switchLanguage()
      this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + this.$refs.pagination.offsetHeight + 53)
      this.getAbsences()
    },
    methods: {
      getAbsences (filter = false) {
        let self = this
        if (filter) {
          self.currentPage = 1
          self.visitedPage = [1]
          self.new_page = true
          self.absences[self.absenceFrom] = {}
        }
        if (self.absences[self.absenceFrom][self.currentPage - 1] !== undefined) return
        this.$http.get('/absence?' + qs.stringify(self.bindCurrentFilters()) + '&type=' + self.absenceFrom + '&limit=' + self.limit + '&offset=' + self.limit * (self.currentPage - 1))
          .then(function (response) {
            Vue.set(self.absences[self.absenceFrom], self.currentPage - 1, response.data.absences)
            self.totalAbsences = response.data.total
            self.new_page = self.loading = false
            if (_.isEmpty(self.absence) && self.$route.params.id) self.getAbsence()
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      date_format (date) {
        if (date === null) return
        return this.$moment(date).format('DD/MM/YYYY')
      },
      getAbsence () {
        let self = this
        this.$http.get('/absence/' + this.$route.params.id)
          .then(function (response) {
            self.showAbsence(response.data.absence)
          })
      },
      bindCurrentFilters () {
        let data = {filters: []}
        if (_.isEmpty(this.active_filter)) return
        switch (this.active_filter) {
          case 'reason': data.filters['Reason'] = this.Reason
            break
          case 'name': data.filters['StudentID'] = this.StudentID
            break
          case 'date':
            if (_.isNull(this.date[0]) && _.isNull(this.date[1])) break
            data.filters['minDate'] = this.$moment(this.date[0]).format('YYYY-MM-DD')
            data.filters['maxDate'] = this.$moment(this.date[1]).format('YYYY-MM-DD')
            break
        }
        return data
      },
      changeFilter () {
        this.Reason = ''
      },
      switchTo () {
        this.absenceFrom = this.absenceFrom === 'bus' ? 'school' : 'bus'
        this.currentPage = 1
        this.visitedPage = [1]
        this.new_page = true
        this.absences[this.absenceFrom] = {}
        this.getAbsences()
      },
      addAbsence () {
        this.absence = {AbsentID: null, StudentID: null, AbsentDate: null, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0}
        this.serverCheck = true
        this.serachStudent = true
        this.absenceBox = true
      },
      showAbsence (absence, index = null) {
        this.pickedIndex = index
        this.absence_status = absence.Status === 1
        this.absence = _.pick(absence, ['AbsentID', 'StudentID', 'AbsentDate', 'Reason', 'OnlyFromBus', 'Trip', 'FromBMMA'])
        this.student = _.pick(absence, ['StudentID', 'FullName_EN', 'FullName_AR', 'ImagePath'])
        this.absence.Completed = true
        this.absence.Excluded = false
        this.serverCheck = false
        this.serachStudent = false
        this.absenceBox = true
      },
      updateAbsence (_absences) {
        for (let date in _absences) {
          let absenceFrom = _absences[date].OnlyFromBus ? 'bus' : 'school'
          if (!_absences[date].Updated || this.absenceFrom !== absenceFrom) continue
          let absences = this.absences[this.absenceFrom][this.currentPage - 1]
          let self = this
          Object.keys(absences).map(function (key) {
            if (absences[key].AbsentDate === _absences[date].AbsentDate) {
              self.absences[self.absenceFrom][self.currentPage - 1][key] = _.merge(absences[key], _absences[date])
              self.updateDirection(self.absences[self.absenceFrom][self.currentPage - 1][key])
            }
          })
        }
      },
      updateDirection (absence) {
        switch (absence.Trip) {
          case 1:
            absence.Direction.icon = 'morning-icon'
            absence.Direction.title = 'MORNINGBUS'
            break
          case 2:
            absence.Direction.icon = 'evening-icon'
            absence.Direction.title = 'AFTERNOONBUS'
            break
          case 3:
            absence.Direction.icon = 'from-bus'
            absence.Direction.title = 'NOBUS'
            break
        }
      },
      handleSizeChange (val) {
        this.limit = val
        this.absences[this.absenceFrom] = {}
        this.currentPage = 1
        this.visitedPage = [1]
        this.loading = true
        this.getAbsences()
      },
      handleCurrentChange (val) {
        if (isNaN(val)) return
        this.currentPage = val
        if (this.visitedPage.indexOf(val) >= 0) return
        this.visitedPage.push(val)
        this.new_page = true
        this.getAbsences()
      },
      preDelete (index) {
        let self = this
        self.listAbsences[self.prevIndex].Deleted = false
        self.prevIndex = index
        self.listAbsences[self.prevIndex].Deleted = true
      },
      toggleStatus (index) {
        let self = this
        let postData = {AbsentID: self.listAbsences[index].AbsentID, StudentID: self.listAbsences[index].StudentID, Status: self.listAbsences[index].Status, DeleteNote: (self.listAbsences[index].DeleteNote === null) ? '' : self.listAbsences[index].DeleteNote}
        this.$http.post('/absence/delete', postData)
          .then(function (response) {
            self.listAbsences[index].Deleted = false
            self.listAbsences[index].DeletedAt = self.listAbsences[index].DeletedAt !== null ? null : ''
            self.listAbsences[index].Status = self.listAbsences[index].Status === 1 ? 0 : 1
            if (!response.data.error) self.getAbsences(true)
            self.$message({
              message: (!response.data.error) ? self.$t('SUCCESSFULLYDELETED') : self.$t('OPERATIONFAILED'),
              type: !response.data.error ? 'success' : 'error',
              showClose: true
            })
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      showMessageModal (student) {
        let self = this
        self.messageStudent = []
        this.$http.get('/student/relation?StudentID=' + student.StudentID)
          .then(function (response) {
            if (_.isEmpty(response.data)) {
              return self.$message({
                message: self.$t('STUDENTHASNOGUARDIAN'),
                type: 'warning',
                showClose: true
              })
            } else {
              self.messageStudent.push(student)
              self.parent = response.data
              self.messageBox = true
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      querySearch (queryString, cb) {
        let self = this
        if (_.isEmpty(self.FullName)) return
        if (self.autoSource) self.autoSource.cancel()
        let result = self.findStudent(queryString)
        result.then(function (response) {
          self.autoSource = null
          cb(!response.data ? [] : response.data)
        }).catch(function () {
        })
      },
      findStudent (queryString) {
        this.autoSource = axios.CancelToken.source()
        return this.$http.get('/student/find?term=' + queryString + '&lang=' + localStorage.getItem('lang') + '&from=route', {cancelToken: this.autoSource.token})
      },
      searchStudent (data) {
        this.StudentID = data.student.StudentID
        this.getAbsences(true)
      },
      removeNameFilter () {
        this.FullName = null
        this.StudentID = null
        this.getAbsences(true)
      },
      changedFilter (val) {
        if (val === null) return
        this.active_filter = val
        this.filter = null
        let load = false
        if (this.FullName !== null || this.Reason !== null || (this.date[0] !== null && this.date[1] !== null)) load = true
        if (load) {
          this.FullName = this.Reason = null
          this.date = [null, null]
          this.getAbsences(true)
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Absence.vue?b13cd68a